import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { deleteNews } from '../../sources/news';
import { remove, grids } from '../queryKeyFactory';

export const useRemoveNews = () => {
  const confirm = useScreenModalV2(ConfirmDialog);
  const removeMutation = useMutation(remove(), deleteNews, {
    refreshOptions: { queryKey: grids() },
    successMessage: () => 'News was removed',
  });

  const handleRemove = async ({ id }) => {
    await confirm({
      title: 'Are you sure you want to delete this item?',
      confirmActionLabel: 'Delete',
    });
    await removeMutation.mutateAsync({ id });
  };
  return [handleRemove, removeMutation];
};
